import { API_URL, fetchWithHandling } from './api';

// ---------------------------------------------------------------------------
// Mail API Functions
//
// The mail signature is found automatically by the backend (Sent Items, else
// the Microsoft profile) and appended to every mail sent from chat — the user
// never has to type it. These calls only let the approval card preview it and
// let Settings show it (read-only). Same auth shape as skillsApi.js.
//
// Responses are the AppResponse envelope: { success, data, message }.
// getMailProfile() returns data: null when nothing is stored yet and Outlook
// isn't connected.
// ---------------------------------------------------------------------------

export async function getMailProfile(accessToken) {
  return fetchWithHandling(`${API_URL}/data/mail/profile`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  });
}

/**
 * Change a setting. Omit a field to leave it; an empty tone falls back to the
 * default tone. The signature isn't here: it's read-only, from the mailbox
 * (syncWithOutlook reads it again).
 */
export async function updateMailProfile(
  accessToken,
  { signatureEnabled, toneInternal, toneExternal } = {},
) {
  const body = {};
  if (signatureEnabled !== undefined) body.signature_enabled = signatureEnabled;
  if (toneInternal !== undefined) body.tone_internal = toneInternal;
  if (toneExternal !== undefined) body.tone_external = toneExternal;
  return fetchWithHandling(`${API_URL}/data/mail/profile`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(body),
  });
}

/**
 * What happens to a drafted mail when approved: { audience: internal |
 * external | mixed | unknown, relation: manager | team | null,
 * signature_html, warnings: [...] }.
 */
export async function previewMail(accessToken, draft) {
  return fetchWithHandling(`${API_URL}/data/mail/preview`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(draft),
  });
}

/**
 * Sync with Outlook: read the signature, company domains, manager and direct
 * reports again, and re-learn how the user writes.
 */
export async function syncWithOutlook(accessToken) {
  return fetchWithHandling(`${API_URL}/data/mail/sync`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  });
}
